// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CheckboxSwitch_wrap__3W2nR","switcherChecked":"CheckboxSwitch_switcherChecked__1JV8Z","switcher":"CheckboxSwitch_switcher__22LRi"};